<app-widget-asset-list [autoFocusSearch]="false" [dataTestId]="'formly-asset-list'" />
